import React, {Component} from 'react'
import {connect} from 'react-redux';

import GuestBookCommentTrashListHeader from '../../components/comments/guestBookCommentTrash/GuestBookCommentTrashListHeader'
import GuestBookCommentTrashList from '../../components/comments/guestBookCommentTrash/GuestBookCommentTrashList'
import Pagination from '../../components/common/Pagination';
import ListTitle from "../../components/common/list/ListTitle";
import {parseListParams} from '../../components/common/CommentListHelper';
import * as InitStatus from "../../constants/common/InitializationStatus";
import autobind from "autobind-decorator";
import {number_format} from "../../utils/formatter";

@connect(state => ({
  items: state.guestbookCommentTrash.item.items,
  totalCount: state.guestbookCommentTrash.item.totalCount,
  searchKeyword: state.guestbookCommentTrash.condition.searchKeyword,
}))
class CommentApp extends Component {

  constructor(props) {
    super(props);
    this.state = {headerStatus: InitStatus.INIT_READY}
  }

  // Header process 상태
  @autobind
  handleSetHeaderStatus(status) {
    this.setState({headerStatus: status});
  }

  render() {
    const {totalCount, searchKeyword} = this.props;
    const {headerStatus} = this.state;

    return (
      <div className="inner_article reply_article">
        <h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
        <ListTitle headTitle="방명록 휴지통" totalCount={number_format(totalCount)} searchKeyword={searchKeyword}/>
        <GuestBookCommentTrashListHeader handleSetHeaderStatus={this.handleSetHeaderStatus}/>
        <GuestBookCommentTrashList headerStatus={headerStatus}/>
        <Pagination totalCount={totalCount} parseListParams={parseListParams}/>
      </div>
    )
  }
}

export default CommentApp;
